import React from "react";
import styles from "./ChartBlock.module.css";
import DeleteButton from "../../../reusable/Button/DeleteButton";
import Chart from "../../../charts/helpers/Chart";

export default function ChartBlock({
	chartType,
	chartData,
	chartConfig,
	onDelete,
}) {
	return (
		<div className={styles.chartBlock}>
			<div className={styles.deleteBtn}>
				<DeleteButton action={() => onDelete()} />
			</div>
			<div className={styles.chart}>
				<Chart
					chartType={chartType}
					chartData={chartData}
					chartConfig={chartConfig}
				/>
			</div>
		</div>
	);
}
